import { createContext } from 'react'

type Theme = 'dark' | 'light' | 'system'

export interface ThemeContextValue {
  theme: Theme
  setTheme: (theme: Theme) => void
  resolvedTheme: 'dark' | 'light'
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
